import guideGlobalSearchResultItem from './GuideGlobalSearchResultItem';

export default guideGlobalSearchResultItem;
